module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/photography-detail-1.90298cc2.webp";